import React, { useState, useEffect } from 'react';
import iconRefresh from '../../Images/icon_refresh.png';
export const Captcha = (props) => {

    return (
        <div style={{ width: "100%" }}>
            <img src={"data:image/gif;base64," + props.Img} alt="Red dot" style={{ width: "80%" }} />
            <a href="/" onClick={(e) => {
                e.preventDefault();
                props.GetCaptcha(e)
            }}>
                <img src={iconRefresh} style={{ width: "20%" }} alt='' />
            </a>
        </div>
    );
}
export default React.memo(Captcha)